module.exports = __webpack_public_path__ + "icon-framework-karma.2JcuxA_N.svg";